module.exports = __webpack_public_path__ + "a19cddcf2230a1cf6fa3210ec9b4df85.ttf";